<app-frame [frameSrc]="url" id="ALGS"></app-frame>
